<script lang="ts">
  import Loading from '$lib/components/Loading.svelte';
  import LogInSplash from '$lib/components/LogInSplash.svelte';
  import { auth } from '$lib/stores/auth.svelte';
  import type { LayoutProps } from './$types';

  let { children }: LayoutProps = $props();
</script>

{#if auth.user}
  {@render children?.()}
{:else if auth.loading}
  <main id="main-content" class="container py-3">
    <Loading />
  </main>
{:else}
  <LogInSplash />
{/if}
